import { motion } from "framer-motion";
import { Building2, Droplet, Sparkles, BadgeCheck } from "lucide-react";

const features = [
  {
    icon: Building2,
    title: "Apartment-first",
    body: "Geofenced operations, RWA approvals, lift-friendly equipment.",
  },
  {
    icon: Droplet,
    title: "Waterless nano-tech",
    body: "Premium polymer formulations. 0 litres per wash. Society-approved.",
  },
  {
    icon: Sparkles,
    title: "Consistent finish",
    body: "Same SOP, same products, every single visit — premium-car grade.",
  },
  {
    icon: BadgeCheck,
    title: "Trained Zyppers",
    body: "Background-checked, insured, certified professionals — never gig drifters.",
  },
];

export default function Solution() {
  return (
    <section
      data-testid="solution-features"
      className="relative py-24 md:py-32 px-6 md:px-12 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <div className="text-xs uppercase tracking-[0.22em] text-[#FF5A00] mb-4">
              Why Zyp
            </div>
            <h2 className="font-heading text-4xl sm:text-5xl font-medium tracking-tight">
              Not another car wash. <br />
              A car ownership operating system.
            </h2>
          </div>
          <p className="md:max-w-sm text-zinc-400">
            Built ground-up for the realities of urban Indian apartments. Every
            decision optimised for trust, time and turn-up.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((f, i) => (
            <motion.div
              key={f.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              data-testid={`solution-feature-${i}`}
              className="rounded-2xl border border-white/5 bg-zinc-950/40 hover:bg-zinc-900/60 hover:border-white/15 transition-all p-8 h-full"
            >
              <div className="h-12 w-12 rounded-xl bg-[#FF5A00]/10 border border-[#FF5A00]/20 flex items-center justify-center mb-6">
                <f.icon size={22} className="text-[#FF5A00]" strokeWidth={1.6} />
              </div>
              <h3 className="font-heading text-xl font-medium tracking-tight">
                {f.title}
              </h3>
              <p className="mt-2 text-zinc-400 text-sm leading-relaxed">
                {f.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
